<template>
  <div class="ai-training-page">
    <!-- 保留原 Header 的数据加载与返回逻辑，仅隐藏旧视觉。 -->
    <Header class="wait-robot-legacy-header"></Header>

    <header class="ai-training-header">
      <a class="ai-training-back" href="#/quizCenter" :aria-label="$t('Back')">
        <img src="../../static/images/livequiz/back.png" alt="">
      </a>
    </header>

    <main class="ai-training-main">
      <img class="ai-training-title" src="../../static/images/ai_training/ai_training_tile.png" :alt="$t('game1T')">

      <section class="ai-training-panel" :aria-label="$t('game1T')">
        <img class="ai-training-panel-bg" src="../../static/images/ai_training/ai_training_bg.png" alt="">
        <div class="ai-training-panel-content">
          <p class="ai-training-intro">{{$t('game1C')}}</p>
          <div class="ai-training-hero-art" aria-hidden="true">
            <img src="../../static/images/ai_training/select_difficulty_photo.png" alt="">
          </div>

          <div class="ai-training-difficulty">
            <p>{{$t('game1Tips1')}}</p>
            <button class="ai-training-level ai-training-level-easy" type="button" @click="getRobot3('Easy')">
              <img src="../../static/images/ai_training/easy.png" alt="">
              <span>{{$t('Easy')}}</span>
            </button>
            <button class="ai-training-level ai-training-level-medium" type="button" @click="getRobot3('Medium')">
              <img src="../../static/images/ai_training/medium.png" alt="">
              <span>{{$t('Medium')}}</span>
            </button>
            <button class="ai-training-level ai-training-level-hard" type="button" @click="getRobot3('Hard')">
              <img src="../../static/images/ai_training/hard.png" alt="">
              <span>{{$t('Hard')}}</span>
            </button>
          </div>
        </div>
      </section>
    </main>

    <div class="wait-robot-buy-popup" v-if="showBuyMorePopup">
      <div class="wait-robot-buy-popup-mask" @click="cancelOtpDialog"></div>
      <section class="wait-robot-buy-popup-dialog" role="dialog" aria-modal="true" :aria-label="$t('BuyChances')">
        <div class="wait-robot-buy-popup-header">
          <img src="../../static/images/buy_more/pop_up_header.png" alt="">
          <h2>{{ $t('BuyChances') }}</h2>
        </div>
        <div class="wait-robot-buy-popup-card">
          <img class="wait-robot-buy-popup-card-bg" src="../../static/images/buy_more/buy_chance_pop_up_bg.png" alt="">
          <div class="wait-robot-buy-popup-content">
            <p>
              <span>{{ $t('BuyMoreChancesCopy') }}</span>
              <span>{{ $t('BuyMoreChancesWin') }} <strong>{{ $t('BuyMoreChancesHighlight') }}</strong></span>
            </p>
            <img class="wait-robot-buy-popup-hero" src="../../static/images/buy_more/buy_chance_photo.png" alt="">
            <button class="wait-robot-buy-popup-option" type="button" @click="getSubmit">
              <img class="wait-robot-buy-popup-option-bg" src="../../static/images/buy_more/chance_bg.png" alt="">
              <img src="../../static/images/buy_more/one_time_purchase.png" :alt="$t('one_time_purchase')">
              <span>{{ $t('one_time_purchase') }}</span>
            </button>
            <div class="wait-robot-buy-popup-balance">
              <span>{{ $t('CurrentChances') }}</span>
              <img src="../../static/images/home/chance.png" alt="">
              <strong>{{ info.score || 0 }}</strong>
            </div>
          </div>
        </div>
        <button class="wait-robot-buy-popup-close" type="button" :aria-label="$t('Later')" @click="cancelOtpDialog">
          <img src="../../static/images/buy_more/close.png" alt="">
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import Header from '../components/HeaderOne'
export default {
    components:{
		Header
    },
  data() {
    return {
      otp:'',
      codeText:'',
      score:'',
      info:{},
      showBuyMorePopup: false,
      backgroundAudio: null
    }
  },
  created() {
    this.getUserInfo();

  },
  beforeDestroy() {

  },
  methods: {
    getRobot3(type){
      this.$router.push({path:'/robot',query: {type:type}});
    },
    getUserInfo(){
      let that =this;
      that.$api.get('/api/user/info',null,r =>{
        that.$parent.returnCode(r,function(){
          that.info = r.data
          if (r.data.score < 1 ){
            that.showBuyMorePopup = true;
          }
        });
      })
    },
    cancelOtpDialog(){
      this.showBuyMorePopup = false;
      this.$router.push({path:'/'});
    },
    getSubmit(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy',null,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code == 1){
            that.showBuyMorePopup = false;
            that.$utils.alertText(r.msg,80, 800);
          }else{
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
  }
}
</script>

<style scoped>
.ai-training-page { position:relative; min-height:100vh; box-sizing:border-box; isolation:isolate; padding:46px 28px 96px; color:#fff; background:#06021d url('../../static/images/livequiz/main_bg.jpg') center top/100% 100% no-repeat; font-family:Arial, Atom-sans, sans-serif; }
.ai-training-page::before { position:absolute; z-index:0; inset:0; content:''; background:rgba(7,0,26,.18); pointer-events:none; }
.wait-robot-legacy-header { display:none; }
.ai-training-header,.ai-training-main { position:relative; z-index:1; width:100%; max-width:650px; margin:0 auto; }
.ai-training-header { position:absolute; z-index:2; top:46px; right:0; left:0; width:calc(100% - 56px); }
.ai-training-back { display:flex; width:72px; height:72px; align-items:center; justify-content:center; padding:0; border:0; background:transparent; }
.ai-training-back img { display:block; width:100%; height:100%; object-fit:contain; }
.ai-training-title { display:block; width:min(118%, 680px); margin:0 auto 58px; }
.ai-training-panel { position:relative; width:100%; aspect-ratio:1046 / 1420; overflow:hidden; }
.ai-training-panel-bg { position:absolute; inset:0; display:block; width:100%; height:100%; }
.ai-training-panel-content { position:absolute; inset:0; display:flex; align-items:center; flex-direction:column; box-sizing:border-box; padding:8.5% 7% 7%; text-align:center; }
.ai-training-intro { width:92%; min-height:16%; margin:0; color:#fff; font-size:clamp(18px, 5vw, 34px); font-weight:500; text-shadow:0 3px 7px rgba(18,0,35,.74); }
.ai-training-hero-art { display:flex; width:82%; height:32%; align-items:center; justify-content:center; margin:0 auto; }
.ai-training-hero-art img { display:block; width:120%; max-width:none; height:auto; object-fit:contain; }
.ai-training-difficulty { width:91%; margin-top:auto; }
.ai-training-difficulty > p { margin:0 0 7%; color:#ffe600; font-size:clamp(18px, 5.2vw, 35px); font-weight:500; line-height:1.12; }
.ai-training-level { position:relative; display:flex; width:100%; aspect-ratio:896 / 162; align-items:center; justify-content:center; margin-top:4.6%; padding:0; border:0; background:transparent; color:#fff; font:inherit; }
.ai-training-level img { position:absolute; inset:0; display:block; width:100%; height:100%; }
.ai-training-level span { position:relative; z-index:1; font-size:clamp(20px, 6vw, 39px); font-weight:800; line-height:1; text-shadow:0 3px 6px rgba(0,0,0,.48); }
.ai-training-level-easy span { color:#3dff5b; }
.ai-training-level-medium span { color:#ffeb00; }
.ai-training-level-hard span { color:#ff58a7; }

.wait-robot-buy-popup { position:fixed; z-index:120; inset:0; }
.wait-robot-buy-popup-mask { position:absolute; inset:0; background:rgba(0,0,0,.82); }
.wait-robot-buy-popup-dialog { position:absolute; top:12.2vh; left:50%; width:min(calc(100% - 28px),750px); transform:translateX(-50%); }
.wait-robot-buy-popup-header { position:relative; z-index:2; }
.wait-robot-buy-popup-header > img { display:block; width:100%; }
.wait-robot-buy-popup-header h2 { position:absolute; top:68%; right:10%; left:10%; margin:0; transform:translateY(-50%); color:#fff; font-size:clamp(25px,6.6vw,48px); font-weight:900; line-height:1; letter-spacing:-.035em; text-align:center; text-shadow:0 3px 2px #942006,0 0 8px rgba(255,190,35,.85); -webkit-text-stroke:1px #9d2a06; text-transform:uppercase; white-space:nowrap; }
.wait-robot-buy-popup-card { position:relative; margin-top:-5.5%; }
.wait-robot-buy-popup-card-bg { display:block; width:100%; }
.wait-robot-buy-popup-content { position:absolute; inset:0; display:flex; align-items:center; box-sizing:border-box; flex-direction:column; padding:12% 8% 7%; }
.wait-robot-buy-popup-content > p { width:90%; margin:0; color:#fff; font-size:clamp(15px,4vw,30px); font-weight:500; line-height:1.08; text-align:center; }
.wait-robot-buy-popup-content > p span { display:block; }
.wait-robot-buy-popup-content > p strong { color:#ffde00; font-weight:800; }
.wait-robot-buy-popup-hero { display:block; width:72%; object-fit:contain; }
.wait-robot-buy-popup-option { position:relative; width:38%; min-width:132px; overflow:hidden; border:0; border-radius:15px; padding:3% 2% 6%; background:#24213e; color:#fff; cursor:pointer; font:inherit; }
.wait-robot-buy-popup-option::before { position:absolute; inset:0; content:''; border:1px solid rgba(255,255,255,.05); border-radius:inherit; background:linear-gradient(180deg,rgba(255,255,255,.08),transparent 55%); pointer-events:none; }
.wait-robot-buy-popup-option > img:not(.wait-robot-buy-popup-option-bg) { position:relative; z-index:1; display:block; width:56%; margin:0 auto; }
.wait-robot-buy-popup-option-bg { position:absolute; inset:0; width:100%; height:100%; opacity:.52; object-fit:cover; }
.wait-robot-buy-popup-option span { position:relative; z-index:1; display:block; margin-top:1%; color:#fff; font-size:clamp(13px,4vw,30px); font-weight:500; line-height:1.08; text-align:center; }
.wait-robot-buy-popup-balance { display:flex; align-items:center; justify-content:center; gap:6px; margin-top:20px; color:#ffe878; font-size:clamp(14px,4.2vw,30px); font-weight:500; line-height:1; text-align:center; }
.wait-robot-buy-popup-balance img { width:clamp(22px,6vw,44px); height:clamp(22px,6vw,44px); object-fit:contain; }
.wait-robot-buy-popup-balance strong { color:#fff; font-size:1.05em; }
.wait-robot-buy-popup-close { display:block; width:clamp(42px,13vw,96px); margin:5% auto 0; padding:0; border:0; background:transparent; cursor:pointer; }
.wait-robot-buy-popup-close img { display:block; width:100%; }

@media (min-width:760px) {
  .ai-training-title { margin-bottom:72px; }
}
</style>



// WEBPACK FOOTER //
// src/page/waitRobot.vue